import { Component, OnInit } from '@angular/core';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ReviewerDetailDialogService } from '../../../../../../../shared/services/reviewer-detail-dialog.service';

@Component({
  selector: 'app-view-users-modal',
  providers: [DialogService],
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    CommonModule,
    DynamicDialogModule,
    TableModule,
    TagModule,
  ],
  templateUrl: './view-users-modal.component.html',
})
export class ViewUsersModalComponent implements OnInit {
  users: any[] = [];
  jobTypeName: string = '';
  showDeleteOption: boolean = false;
  deleteMessage: string = '';
  onDelete: (() => void) | null = null;
  showUsersOnly: boolean = false;
  showDeleteConfirmation: boolean = true;
  actionLabel: string = 'Delete';
  totalReviewersCountMessage: string = '';
  constructor(
    public ref: DynamicDialogRef,
    public dialogService: DialogService,
    public config: DynamicDialogConfig,
    private reviewerDetailDialogService: ReviewerDetailDialogService,
  ) {}

  ngOnInit() {
    this.users = this.config?.data?.users || [];
    this.jobTypeName = this.config?.data?.jobTypeName || '';
    this.showDeleteOption = this.config?.data?.showDeleteOption || false;
    this.deleteMessage = this.config?.data?.deleteMessage || '';
    this.onDelete = this.config?.data?.onDelete || null;
    this.showUsersOnly = this.config?.data?.showUsersOnly || false;
    this.actionLabel = this.config?.data?.actionLabel || 'Delete';
    this.totalReviewersCountMessage = this.config?.data?.totalReviewersCountMessage || '';
    if (this.showUsersOnly) {
      this.showDeleteConfirmation = false;
    }
  }

  confirmDelete() {
    if (this.onDelete) {
      this.onDelete();
    }
    this.ref.close();
  }

  viewUsersOnly() {
    this.showUsersOnly = true;
    this.showDeleteConfirmation = false;
  }

  openReviewerDialog(id:string){
    this.reviewerDetailDialogService.openDialog(id);
  }

  closeDialog() {
    this.ref.close();
  }
}